import TaskIcon from 'src/assets/icons/fi-rr-list-check.svg';
import { FieldMappingsMockUpType } from '../types';

export const selectedData = {
  value: '',
  to_crm_if_blank: true,
  from_sprouts: false,
  nosync: false,
  // crm to sproutes
  toSprouts: true,
  dontSyncToSprouts: false,
};
export const selectedDataNew = {
  value: '',
  to_crm_if_blank: false,
  from_sprouts: true,
  nosync: false,
  // crm to sproutes
  toSprouts: true,
  dontSyncToSprouts: false,
};
export const TaskFieldMappings: FieldMappingsMockUpType = {
  id: 'task',
  label: 'Task',
  testRunId: 'tasks',
  testRunLabel: 'Tasks',
  icon: TaskIcon,
  desc: 'Fields mapped',
  count: '0',
  entity: 'Tasks',
  sproutsFields: [
    {
      label: 'Task Name',
      id: 'taskName',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Entity Type',
      id: 'entityType',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Status',
      id: 'status',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Created At',
      id: 'createdAt',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Updated At',
      id: 'updatedAt',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Execution Time',
      id: 'executionTime',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Completion Time',
      id: 'completionTime',
      selectedData,
      onlyOutbound: false,
    },
    // {
    //   label: 'Assigned User ID',
    //   id: 'assignedUserId',
    //   selectedData,
    //   onlyOutbound:false,
    // },
    // {
    //   label: 'Creation Source',
    //   id: 'creationSource',
    //   selectedData,
    //   onlyOutbound:false,
    // },
    {
      label: 'Sequence ID',
      id: 'sequenceId',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Description',
      id: 'body',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Due Date',
      id: 'dueTo',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'CMP ID',
      id: 'cmpId',
      selectedData,
      required: true,
      onlyOutbound: false,
    },
    {
      label: 'Owner ID',
      id: 'ownerId',
      selectedData,
      required: true,
      onlyOutbound: false,
    },
    {
      label: 'Contact ID',
      id: 'contactId',
      selectedData,
      required: true,
      onlyOutbound: false,
    },
    {
      label: 'Step ID',
      id: 'stepId',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Completed',
      id: 'completed',
      selectedData,
      onlyOutbound: false,
    },
  ],
};

// Expanded activity task field mappings
export const TaskFieldMappingsExpandedActivity: FieldMappingsMockUpType = {
  id: 'task',
  label: 'Task',
  testRunId: 'tasks',
  testRunLabel: 'Tasks',
  icon: TaskIcon,
  desc: 'Fields mapped',
  count: '0',
  entity: 'Tasks',
  sproutsFields: [
    {
      label: 'Task Subject',
      id: 'taskName',
      selectedData: selectedDataNew,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
      required: true,
    },
    {
      label: 'Task Body',
      id: 'body',
      selectedData: selectedDataNew,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
      required: true,
    },
     {
      label: 'Status',
      id: 'status',
      selectedData: selectedDataNew,
      supportedTypes: ['Object','String'],
      onlyOutbound: false,
      disableToCrmIfBlank: true,
      required: true,
    },
    //     {
    //   label: 'Task Type',
    //   id: 'type',
    //   selectedData: selectedDataNew,
    //   onlyOutbound: false,
    //   disableToCrmIfBlank: true,
    // },
    {
      label: 'Task SubType',
      id: 'entityType',
      selectedData: selectedDataNew,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
      required: true,
    },
    {
      label: 'Sequence Name',
      id: 'sequenceName',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Step Number',
      id: 'stepNumber',
      selectedData: selectedDataNew,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Activity time',
      id: 'executionTime',
      selectedData: selectedDataNew,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
    },
  ],
};
